

























































import schema from 'async-validator'
import { Form, FormItem, Input, Button } from 'element-ui'
import { mixins } from 'vue-class-component'
import { Vue, Component, Prop, Ref } from 'vue-property-decorator'

import Checkbox from '@/components/Checkbox.vue'
import CustomInput from '@/components/CustomInput.vue'

import LoginData from '@/models/login-data'

import GroupedErrorValidationMixin from '@/mixins/GroupedErrorValidationMixin.vue'

@Component({
  components: {
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Input.name]: Input,
    [Button.name]: Button,
    Checkbox,
    CustomInput,
  },
})
export default class LoginForm extends mixins(GroupedErrorValidationMixin) {
  @Prop() errorMessage!: string
  @Prop() pending!: boolean
  @Prop() prefilledEmail!: string
  @Ref() readonly loginForm!: Form

  form: LoginData = {
    email: this.prefilledEmail || '',
    password: '',
    rememberMe: false,
  }

  readonly rules = {
    email: [
      { required: true, message: 'Please enter your Email', trigger: 'blur' },
      { type: 'email', message: 'Wrong email format', trigger: 'blur' },
    ],
    password: [
      {
        required: true,
        message: 'Please enter your Password',
        trigger: 'blur',
      },
    ],
  }

  readonly validator = new schema(this.rules)

  get serverError() {
    if (this.$validator.errors.any()) {
      return ''
    }

    return this.errorMessage
  }

  handleLogin() {
    this.loginForm.validate((isValid) => {
      if (isValid) {
        this.$emit('on-login', {
          ...this.form,
          invitationToken: this.$route.params.autologinToken,
        })
      }
    })
  }
}
